import React from 'react';

import {getPickMarket, getPickSelection, getPickTimestamp} from './helpers';

import PickReason from './components/PickReason';
import PickOdds from './components/PickOdds';
import PickTime from './components/PickTime';
import PickScore from './components/PickScore';

import './pick.scss';

const Pick = ({pick}) => (
  <div className="pick">
    <div className="pick-header">
      <div className="pick-selection">{getPickSelection(pick)}</div>
      <PickOdds pick={pick} />
    </div>
    <div className="pick-market">{getPickMarket(pick.pick)}</div>
    <div className="pick-event">
      <PickTime timestamp={getPickTimestamp(pick.event)} />
      <div className="pick-sides">
        {pick.event.home && pick.event.home.name} - {pick.event.away && pick.event.away.name}
      </div>
      <PickScore pick={pick} />
    </div>
    <PickReason pick={pick} />
  </div>
);

export default Pick;
